(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('OutBoundController', OutBoundController);

    OutBoundController.$inject = ['$scope', 'Principal', 'OutBound', '$state','User','MessageService', 'ParseLinks', 'SalesOrder',
    '$uibModal', 'Supplier','Product', '$localStorage','$http', '$stateParams', '$rootScope', '$location', 'DateUtils'];

    function OutBoundController ($scope, Principal, OutBound, $state,User,MessageService, ParseLinks, SalesOrder,
        $uibModal, Supplier, Product, $localStorage, $http, $stateParams, $rootScope, $location, DateUtils) {
        var vm = this;

        // 判断是否具有当前页面的访问权限
        Principal.hasAuthority('ROLE_INVENTORY_STOCK_OUT').then(function (data) {
            if (!data) {
                MessageService.error("不好意思，你不具有订单访问的权限！");
                $state.go("home");
            }
        });
        vm.token = $localStorage.authenticationToken;
        vm.dateType = 'businessTime'
        vm.pageSize = [
            {name:'10', value:10},
            {name:'15', value: 15},
            {name:'20', value: 20},
            {name:'30', value: 30},
            {name:'40', value: 40},
            {name:'50', value: 50}
        ];

        vm.conditionList = [
            {name:'全部', value:''},
            {name:'未出库', value:'UnShippedOut'},
            {name:'已出库', value:'ShippedOut'},
            {name:'部分出库', value:'PartShippedOut'},
            {name:'已收货', value: 'ShippedIn'},
            {name:'已关闭', value: 'Close'},
        ];
        vm.predicate = 'createdDate';
        vm.resolve = false;

        vm.page = $stateParams.page || $location.search().page;
        vm.tableData = {
            sort: [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')],
            page: Number(vm.page) || 0,
            size: 20,
            storeName: $stateParams.storeName || $location.search().storeName || '',
            payType: $stateParams.payType || $location.search().payType || '',
            state:$stateParams.state || $location.search().state || '',
            stockOrderNumber:$stateParams.stockOrderNumber || $location.search().stockOrderNumber || '',
            startDate: $stateParams.startDate || $location.search().startDate || null,
            endDate: $stateParams.endDate || $location.search().endDate || null,
            back: $stateParams.back || $location.search().back || '',
            number: $stateParams.number || $location.search().number || ''
        };
        angular.element("#startDate").val($stateParams.startDate || $location.search().startDate || null);
        angular.element("#endDate").val($stateParams.endDate || $location.search().endDate || null);

        init();
        function init() {
            vm.tablePitch = '';
            $scope.select_all = false;
            $scope.checked =[];
            vm.tableData.startDate = angular.copy(angular.element("#startDate").val());
            vm.tableData.endDate = angular.copy(angular.element("#endDate").val());

            $location.search({
                'page':vm.tableData.page,
                'state':vm.tableData.state,
                'stockOrderNumber':vm.tableData.stockOrderNumber,
                'startDate':vm.tableData.startDate,
                'storeName':vm.tableData.storeName,
                'payType':vm.tableData.payType,
                'number':vm.tableData.number,
                'endDate':vm.tableData.endDate,
                'back':vm.tableData.back
            });
            vm.tableData.items= getItems()
            var _data = {
                page:vm.tableData.page,
                size:vm.tableData.size,
                sort:vm.tableData.sort,
                items:getItems()
            }
            OutBound.byCondition(_data, function(res, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.queryCount = headers('X-Total-Count');
                vm.salesOrders = res;
                var pages = Math.ceil(vm.queryCount/vm.tableData.size); //得到总页数
                vm.pagecount = pages; //得到总页数
                //调用分页
                laypage({
                    cont: 'paging',
                    curr: (vm.tableData.page + 1), //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    limit: true,
                    jump: function(obj, first){
                        if (!first) {
                            vm.tableData.page = obj.curr - 1;
                            init();
                        }
                    }
                });
            }, function (error) {
            });
        };

        $scope.conditionSelect = function(data){
            vm.tableData.state = data.value;
            vm.tableData.number = '';
            vm.tableData.page = 0;
            init()
        };
        $scope.search = function(){
            vm.tableData.page = 0;
            init();
        };

        $scope.reset = function(){
            vm.isFilter = false;
            vm.tableData = {
                sort: ['createdDate,DESC'],
                page: 0,
                size: 20,
                state:'',
                stockOrderNumber:'',
                startDate: '',
                endDate: '',
                back: '',
                number:'',
                storeName:'',
                payType:'',
            };
            vm.supplier = "";
            vm.product = "";
            angular.element("#startDate").val("");
            angular.element("#endDate").val("");
            init();
            localStorage.removeItem('tableData');
        };


        //导出
        $scope.orderExport = function () {
            var url = 'api/inventory-stock-out/export?number='+ vm.tableData.number + '&storeName=' + vm.tableData.storeName + '&payType=' + vm.tableData.payType + '&stockOrderNumber=' + vm.tableData.stockOrderNumber
            var _startTime = vm.tableData.startDate ? DateUtils.convertLocalDateToServer(vm.tableData.startDate) + "T00:00:00.000Z" : ''
            var _endTime = vm.tableData.endDate ? DateUtils.convertLocalDateToServer(vm.tableData.endDate) + "T23:59:59.000Z" : ''
            if(vm.dateType == 'businessTime'){
                url += '&businessStart=' + _startTime +'&businessEnd=' + _endTime
            }else{
                url += '&outStockStart=' + _startTime +'&outStockEnd=' + _endTime
            }
            $http({
                url: url,
                method: "GET",
                // data: vm.tableData,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "出库单.xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };
        //导出明细
        $scope.orderExportDetails = function () {
            var _data = {
                items:getItems()
            }
            $http({
                url: 'api/inventory-stock-out/exportList',
                method: "POST",
                data: _data,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                // var filename = "采购单" +DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                var filename = "出库明细" + DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (data, status, headers, config) {
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };
        //导出汇总明细
        $scope.exportCountDetails = function () {
            var _data = {
                items:getItems()
            }
            $http({
                url: 'api/inventory-stock-out/exportSummaryList',
                method: "POST",
                data: _data,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': "Bearer " + vm.token
                },
                responseType: 'blob'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "汇总明细" + DateUtils.convertLocalDateToServer(Date.now())+ ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
                MessageService.success("导出成功");
            }).error(function (error, status, headers, config) {
                console.log(error);
                MessageService.error(data.data.message || "导出失败，请重试！");
            });
        };

        function getItems(){
            var items = [{key:'status',op:'in',value:'UnShippedOut;PartShippedOut;ShippedOut;ShippedIn;Close'}]
            if(vm.tableData.stockOrderNumber){
                items.push({key:'stockOrderNumber',op:'=',value:vm.tableData.stockOrderNumber})
            }
            if(vm.tableData.number){
                items.push({key:'number',op:'=',value:vm.tableData.number})
            }
            if(vm.tableData.storeName){
                items.push({key:'storeName',op:'like',value:vm.tableData.storeName})
            }
            if(vm.tableData.payType){
                items.push({key:'payType',op:'=',value:vm.tableData.payType})
            }
            if (vm.tableData.state) {
                items.push({key: "status", op: "=", value: vm.tableData.state});
            };
            if (vm.tableData.startDate) {
                items.push({key: vm.dateType, op: ">=", value: DateUtils.convertLocalDateToServer(vm.tableData.startDate)+"T00:00:00.000Z"});
            };
            if (vm.tableData.endDate) {
                items.push({key: vm.dateType, op: "<=", value: DateUtils.convertLocalDateToServer(vm.tableData.endDate)+"T23:59:59.000Z"});
            };
            return items
        }

        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $rootScope.previousState = from;
            $rootScope.previousParams = fromParams;
        });

        // 处理差异
        $scope.handleDifference = function(item){
            MessageService.confirm("是否确认生成门店入库差异单?", function () {
                OutBound.checkDiff({inventoryStockOutId: item.id}, function () {
                    init();
                    MessageService.success("生成成功");
                }, function (error) {
                    MessageService.error("生成失败，请重试！");
                });
            });
        }

        $scope.getStatus = function(item){
            switch (item) {
                case 'UnShippedOut':
                    return '未出库';
                case 'UnPaid':
                    return '待支付';
                case 'PartShippedOut':
                    return '部分出库';
                case 'Cancelled':
                    return '未支付作废';
                case 'ShippedOut':
                    return '已出库';
                case 'ShippedIn':
                    return '已收货';
                case 'Close':
                    return '已关闭';
                default:
                    return item
            }
        }
        $scope.getPayType = function(item){
            switch (item) {
                case 'CASH':
                    return '现结';
                case 'CHARGE':
                    return '记账';
                default:
                    return item
            }
        }

        //日期
        function GetDateStr(AddDayCount) {
            var dd = new Date();
            dd.setDate(dd.getDate()+AddDayCount);
            var y = dd.getFullYear();
            var m = (dd.getMonth()+1) < 10 ? '0' + (dd.getMonth()+1) : dd.getMonth()+1;//获取当前月份的日期
            var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
            return y+"-"+m+"-"+d;
        }
    }
})();
